<template>
  <div :style="styles.base">
    <c-button ref="button" :style="computedStyle" v-bind="$props"></c-button>
    <c-base-dialog v-model="isShow" :option="option" @close="closeBtnClick" v-transfer-dom>
      <template slot="body">
        <div :class="getCss('reward-tips')">
          <div>{{ rewardTips }}</div>
          <div v-for="(item,index) in packageNames" :key="index">{{ item }}</div>
        </div>
      </template>
    </c-base-dialog>
    <c-base-dialog v-model="isShowPop" :option="popOption" @close="isShowPop=false" v-transfer-dom></c-base-dialog>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin } from '@tencent/ceiba-base-components';
import button from '@tencent/ceiba-act-public-button';
import CDialog from '@tencent/ceiba-base-components/src/components/base-dialog';

export default {
  name: 'CButtonReward',
  components: {
    [button.name]: button,
    [CDialog.name]: CDialog,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'button-reward-',
      status: this.configurationData.lockFlag ? 'lock' : 'reward', // lock, reward, rewarded
      rewardTips: '',
      packageName: '',
      isShow: false,
      isShowPop: false,
    };
  },
  computed: {
    backgroundImageMap() {
      return {
        lock: this.configurationData.lockImg,
        reward: this.configurationData.rewardImg,
        rewarded: this.configurationData.rewardedImg,
      };
    },
    option() {
      return Object.assign({}, this.dialogConfig, {
        header: '温馨提示',
        fotter: false,
      });
    },
    popOption() {
      return Object.assign({}, this.dialogConfig, {
        dialogStyle: {
          backgroundImage: `url(${this.configurationData.popImg})`,
        },
        header: false,
        body: false,
        fotter: false,
      });
    },
    computedStyle() {
      return {
        backgroundImage: `url(${this.backgroundImageMap[this.status]})`,
        left: 0,
        top: 0,
      };
    },
    enable() {
      const packageStatus = this.quaInfo[this.configurationData.flowID];
      if (!packageStatus) return true;
      return !(packageStatus.total > 0 && packageStatus.remain === 0);
    },
    packageNames() {
      return this.packageName ? this.packageName.split(',') : '';
    },
    wrapStyle() {
      return {
        top: this.styles.base.top,
        left: this.styles.base.left,
        width: this.styles.base.width,
        height: this.styles.base.height,
      };
    },
  },
  watch: {
    'configurationData.lockFlag': {
      handler(newVal) {
        console.log('watch lockFlag=', newVal);
        this.status = newVal ? 'lock' : 'reward';
      },
      immediate: true,
    },
  },
  mounted() {
    console.log('version = 1.0.19 configurationData=', this.configurationData);
    this.initialize();
  },
  methods: {
    initialize() {
      if (this.$isInEditor) return;
      this.$refs.button.setClickHandler(this.doReward, {
        forceApp: this.configurationData.forceApp,
        forceLogin: true,
        forceRole: this.actInfo.extendConfig.forceRole,
      });
      const self = this;
      const checkStatus = () => {
        if (self.enable) self.status = 'reward';
        else self.status = 'rewarded';
        console.log('on checkStatus this.status=', self.status);
      };
      const checkLockStatus = () => {
        if (self.enable) self.status = 'lock';
        else self.status = 'rewarded';
        console.log('on checkStatus this.status=', self.status);
      };
      // 不用解锁
      if (!self.configurationData.lockFlag) {
        console.log('on need no  lock role access ', 'not need onRoleReady');
        this.$onQuaRefreshed(checkStatus);
      } else {
        //  需要解锁
        this.$onRoleReady(async () => {
          console.log('on need  lock role access', 'onRoleReady');
          // 有解锁能力
          const notLock = await self.checkIfNotLock();
          console.log('check lockStatus =', notLock);
          if (!notLock) {
            return;
          }
          // 已解锁
          checkStatus();
        });
        this.$onQuaRefreshed(async () => {
          console.log('on need  lock role access', 'onQuaRefreshed');
          // 有解锁能力
          checkLockStatus();
          if (self.status === 'rewarded') {
            return;
          }
          const notLock = await self.checkIfNotLock();
          console.log('check lockStatus =', notLock);
          if (!notLock) {
            return;
          }
          // 已解锁
          checkStatus();
        });
      }
    },
    closeBtnClick() {
      this.isShow = false;
    },
    async checkIfNotLock() {
      try {
        const response = await this.flowRequest({
          flowId: this.configurationData.lockFlowID,
          params: {
            role: this.roleInfo,
          },
        });
        console.log('checkifnotlock and check ret  response=  ', response);
        const {ret = 0} = response
        if (ret !== 0) {
          return  false
        }
        if (response.data.ret) {
          return false;
        }
        return true;
      } catch (e) {
        console.log('checkifnotlock fail,er=', e);
      }
      return false;
    },
    async doReward() {
      this.reportClick({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
      });
      if (this.status !== 'reward') {
        if (this.status === 'lock' && this.configurationData.popImg) {
          this.isShowPop = true;
        }
        return;
      }
      this.rewardTips = '';
      this.packageName = '';
      if (!(await this.doHook({ name: 'before_reward' }))) {
        return;
      }
      const response = await this.flowRequest({
        flowId: this.configurationData.flowID,
        params: {
          role: this.roleInfo,
        },
      });
      this.refreshQua(); // 刷新礼包

      await this.doHook({
        name: 'after_reward',
        options: {
          meta: this.meta,
          configurationData: this.configurationData,
          response,
        },
      });

      // 后置动作，上报等
      if (response.ret || response.data.ret) {
        console.log('response.data.ret');
        this.reportClickRaw({
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: 'reward',
          eventData: {
            gift_id: '',
            status: '0',
          },
        });
        this.alert(response.data.msg || response.msg);
        return;
      }
      this.reportClickRaw({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
        eventKey: 'reward',
        eventData: {
          gift_id: response.data.package_id || '',
          status: '1',
        },
      });
      if (response.data.msg) {
        this.rewardTips = '恭喜你获得了';
        this.packageName = response.data.msg.replace('恭喜您获得了礼包： ', '');
      } else {
        this.rewardTips = '领取成功';
      }
      this.isShow = true;
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
